import { Input } from "@/components/ui/input"
import { ValidationError } from "../form/ValidationError"

interface EmailRecipientInfoProps {
  formData: {
    firstName: string
    lastName: string
    email: string
  }
  handleInputChange: (field: string, value: string) => void
  showErrors: boolean
}

export function EmailRecipientInfoStep({ formData, handleInputChange, showErrors }: EmailRecipientInfoProps) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1 text-[#18375d]">
            First Name <span className="text-[#ea384c]">*</span>
          </label>
          <Input
            value={formData.firstName}
            onChange={(e) => handleInputChange("firstName", e.target.value)}
            placeholder="First Name"
            className={showErrors && !formData.firstName ? "border-[#ea384c]" : ""}
          />
          {showErrors && !formData.firstName && (
            <ValidationError message="First name cannot be blank" />
          )}
        </div>
        <div>
          <label className="block text-sm font-medium mb-1 text-[#18375d]">
            Last Name <span className="text-[#ea384c]">*</span>
          </label>
          <Input
            value={formData.lastName}
            onChange={(e) => handleInputChange("lastName", e.target.value)}
            placeholder="Last Name"
            className={showErrors && !formData.lastName ? "border-[#ea384c]" : ""}
          />
          {showErrors && !formData.lastName && (
            <ValidationError message="Last name cannot be blank" />
          )}
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium mb-1 text-[#18375d]">
          Email <span className="text-[#ea384c]">*</span>
        </label>
        <Input
          type="email"
          value={formData.email}
          onChange={(e) => handleInputChange("email", e.target.value)}
          placeholder="Email Address"
          className={showErrors && !formData.email ? "border-[#ea384c]" : ""}
        />
        {showErrors && !formData.email && (
          <ValidationError message="Email cannot be blank" />
        )}
      </div>
    </div>
  )
}